import React from 'react';

import QueueCard from '@/components/reconciliation/QueueCard';

export default function WorklistNewOrderDetail({ record, actions }) {
  const item = record.source;
  const orderId = item.order.id;

  return (
    <div data-testid={`worklist-new-order-${orderId}`}>
      <QueueCard
        item={item}
        validation={actions.validations[orderId]}
        validating={actions.validatingId === orderId}
        submitting={actions.submittingId === orderId}
        discarding={actions.discardingId === orderId}
        numberConflict={actions.numberConflicts[orderId]}
        manualNumber={actions.manualNumbers[orderId]}
        duplicateAcknowledged={Boolean(actions.duplicateAcknowledgments[orderId])}
        onDuplicateAcknowledgedChange={actions.onDuplicateAcknowledgedChange}
        onManualNumberChange={actions.onManualNumberChange}
        onValidate={actions.onValidate}
        onSubmit={actions.onSubmit}
        onDiscard={actions.onDiscard}
      />
    </div>
  );
}
